var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('referral-list-tab',{attrs:{"title":_vm.title,"count":_vm.referralStats.countForCategory(_vm.category),"count-background-color":_vm.countBackgroundColor,"count-color":_vm.countColor,"active":_vm.active},on:{"activate":_vm.activate}})}
var staticRenderFns = []

export { render, staticRenderFns }